import React from 'react';
import classNames from 'classnames';

import css from './SearchableFilterOptions.module.css';

/**
 * SearchableFilterOptions - A wrapper component that adds a search bar to filter options
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - The filter options to render
 * @param {Function} props.onSearch - Callback to handle search
 * @param {string} props.placeholder - Placeholder text for search input
 * @param {string} props.className - Additional class for container
 * @param {string} props.searchTerm - Controlled search term value from parent
 */
const SearchableFilterOptions = props => {
  const { children, onSearch, placeholder = 'Search...', className, searchTerm = '' } = props;

  const handleSearchChange = e => {
    const value = e.target.value;
    if (onSearch) {
      onSearch(value);
    }
  };

  const handleClearSearch = e => {
    e.preventDefault();
    e.stopPropagation();
    if (onSearch) {
      onSearch('');
    }
  };

  return (
    <div className={classNames(css.root, className)}>
      <div className={css.searchWrapper}>
        <input
          type="text"
          className={css.searchInput}
          placeholder={placeholder}
          value={searchTerm}
          onChange={handleSearchChange}
        />
        {searchTerm && (
          <button
            type="button"
            className={css.clearButton}
            onClick={handleClearSearch}
            aria-label="Clear search"
          >
            ×
          </button>
        )}
      </div>
      <div className={css.optionsWrapper}>
        {children}
      </div>
    </div>
  );
};

export default SearchableFilterOptions;

